import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, InputGroup, Form, Button } from "react-bootstrap";
import { FaRegEnvelope } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import APIServicenew from "../utils/APIGeneralService";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [load, setLoad] = useState(false);
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const headers = { "auth-token": authToken };

  const validate = () => {
    const errors = {};
    if (!email) {
      errors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Email is invalid.";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(true);
    if (validate()) {
      const res = await APIServices.post(
        "admin/auth/forgot_password",
        { email },
        headers
      );
      if (res?.data?.status === true) {
        setLoad(false);
        showToast(res?.data?.message || "Success", "success");
        setTimeout(() => {
          navigate("/reset-password");
        }, 2000);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
        setLoad(false);
      }
    } else {
      setLoad(false);
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (errors.email) {
      setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  return (
    <>
      <div className="login_sec forgot_password_sec">
        <Container fluid className="p-0">
          <Row className="gx-0 align-items-center">
            <Col md={6} lg={6}>
              <div className="login_graph p-4">
                <img
                  src="/images/login_frame.svg"
                  className="img-fluid"
                  alt="login"
                />
              </div>
            </Col>
            <Col md={6} lg={6}>
              <div className="login_form p-4">
                <div className="text-center mb-4">
                  <img
                    src='/images/alf_logo.svg'
                    alt="Logo"
                    className="img-fluid"
                    style={{ width: '200px' }} // Adjust based on logo size
                  />
                </div>
                <h2 className="font_blue_20 font-600 mb-4 line-height26 text-center">
                  Forgot Password?
                </h2>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label className="font_blue_14 font-500 mb-3">
                      Email ID
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="email"
                        placeholder="Enter Email ID"
                        value={email}
                        onChange={handleEmailChange}
                      />
                      <InputGroup.Text>
                        <FaRegEnvelope />
                      </InputGroup.Text>
                    </InputGroup>
                    {errors.email && (
                      <div className="text-danger mt-2">{errors.email}</div>
                    )}
                  </Form.Group>

                  <Button className="btn red_button w-100" type="submit" disabled={load}>
                    {load ? "Processing..." : "Reset Password"}
                  </Button>
                </Form>
                <div
                  className="text-center my-2 pointer"
                  onClick={() => navigate("/")}
                  style={{ cursor: 'pointer' }}
                >
                  Back to <span style={{ color: "blue" }}>Login</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </>
  );
};

export default ForgotPassword;
